import React from 'react';
import { FaUserPlus } from "@react-icons/all-files/fa/FaUserPlus";
import { IoDocumentText } from "@react-icons/all-files/io5/IoDocumentText";
import { IoExitOutline } from "@react-icons/all-files/io5/IoExitOutline";
import { FaProjectDiagram } from "@react-icons/all-files/fa/FaProjectDiagram";
import { FaPaste } from "@react-icons/all-files/fa/FaPaste";
import { IconLayoutGridAdd } from '@tabler/icons-react';


const ContextMenu = (props) => {
    const style = { top: props.y, left: props.x };

    return (
        <div className="circle" style={style}>
            <div className="lil-circle" onClick={props.onClose} style={{ fontSize: '24px', cursor: 'pointer' }}><IoExitOutline style={{ marginLeft: '5px', marginTop: '-5px' }} /></div>
            <button className="btn-inside-circle1" onClick={props.opcion1} style={{ fontSize: '24px' }} title='Agregar Individuo (Alt + i)'><FaUserPlus /></button>
            <button className="btn-inside-circle2" onClick={props.opcion2} style={{ fontSize: '26px' }} title='Vincular Fragmento de texto a Individuo (Alt + t)'><IoDocumentText /></button>
            <button className="btn-inside-circle3" onClick={props.opcion3} style={{ fontSize: '24px' }} title='Agregar Relacion (Alt + p)'><FaProjectDiagram /></button>
            <button className="btn-inside-circle4" onClick={props.opcion4} style={{ fontSize: '24px' }} title='Agregar Objeto (Alt + o)'><IconLayoutGridAdd /></button>
        </div>
    );
};

export default ContextMenu;